export const AUTH_USERNAME = "admin";
export const AUTH_PASSWORD = "NeuroHubs2025qeeg!";

export function isValidUser(user) {
  return (
    !!user &&
    typeof user === "object" &&
    user.name === AUTH_USERNAME &&
    user.password === AUTH_PASSWORD
  );
}
